/**
 * TanStack Query hooks for `data-encryption-at-rest-in-transit`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dataEncryptionAtRestInTransitQueryKeys,
	type CreateDataEncryptionAtRestInTransitBody,
	type ListDataEncryptionAtRestInTransitResponse,
	type DataEncryptionAtRestInTransitRow,
} from "./api";

export function useDataEncryptionAtRestInTransitList(): UseQueryResult<ListDataEncryptionAtRestInTransitResponse, Error> {
	return useQuery({
		queryKey: dataEncryptionAtRestInTransitQueryKeys.list(),
		queryFn: list,
	});
}

export function useDataEncryptionAtRestInTransitCreate(): UseMutationResult<DataEncryptionAtRestInTransitRow, Error, CreateDataEncryptionAtRestInTransitBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataEncryptionAtRestInTransitQueryKeys.all });
		},
	});
}

export function useDataEncryptionAtRestInTransitDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataEncryptionAtRestInTransitQueryKeys.all });
		},
	});
}
